import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Check if all Training Resources have been installed and are ready`}</h2>
    <p>{`You can follow along the process by running:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`./tools/11_practicum/stream_remote_logs.sh                                                 
`}</code></pre>
    <p>{`Or through the OpensHift Web Console:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`ibm-aiops-installer`}</inlineCode>{` Namespace`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Pods`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Click on the `}<inlineCode parentName="p">{`ibm-aiops-install-training-step2-...`}</inlineCode>{` Pod`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Logs`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/06_fzth_aimanager_load.png",
          "alt": "image"
        }}></img>
      </li>
    </ul>
    <p>{`✅ And `}<strong parentName="p">{`when done`}</strong>{` you should get the following with `}<inlineCode parentName="p">{`failed=0`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`
PLAY RECAP *********************************************************************
localhost                  : ok=XXX    changed=XXX    unreachable=0    failed=0    skipped=XXX    rescued=0    ignored=0



*****************************************************************************************************************************
 ✅ DONE
*****************************************************************************************************************************
                                                
`}</code></pre>
    <InlineNotification kind="error" mdxType="InlineNotification">
      <p><strong parentName="p">{`Important - This takes up to 60 minutes`}</strong></p>
      <p>{`This takes some time depending on what region of ROKS you have chosen.`}</p>
      <p>{`Wait for the installation to complete before continuing. `}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      